// Catálogo do cadastro de funcionário: módulos do menu e cargos prontos.
// Precisa bater com backend/api/v1/auth/permissions.py (ROTULOS_MODULOS e
// CARGO_PRESETS). As permissões de ação (caixa, reabrir pedido) moram nas
// features delas e chegam aqui por parâmetro.

export const MODULOS = [
  { id: "visao_geral",   label: "Visão Geral",     hint: "Tela inicial com faturamento e números da loja" },
  { id: "cardapio",      label: "Cardápio",        hint: "Produtos, categorias, pizzas, banners" },
  { id: "estoque",       label: "Estoque",         hint: "Estoque, compras, produção" },
  { id: "pedidos",       label: "Pedidos",         hint: "Acompanhar pedidos" },
  { id: "entregas",      label: "Entregas",        hint: "Tela do entregador" },
  { id: "kds",           label: "KDS (Cozinha)",   hint: "Tela da cozinha" },
  { id: "mesas",         label: "Mesas",           hint: "Operar mesas" },
  { id: "comandas",      label: "Comandas",        hint: "Operar comandas (conta em nome do cliente, sem mesa)" },
  { id: "balcao",        label: "Balcão",          hint: "Vendas no balcão" },
  { id: "delivery",      label: "Delivery",        hint: "Painel de delivery, entregadores" },
  { id: "relatorios",    label: "Relatórios",      hint: "Todos os relatórios" },
  { id: "pessoas",       label: "Pessoas",         hint: "Clientes, fornecedores, funcionários" },
  { id: "localizacao",   label: "Localização",     hint: "Bairros, taxa e pedido mínimo" },
  { id: "financeiro",    label: "Financeiro",      hint: "Caixa, DRE, fluxo de caixa, despesas, formas de pagamento, fiscal" },
  { id: "impulsione",    label: "Impulsione",      hint: "Cupons, campanhas, fidelidade, disparos, anúncios" },
  { id: "chatbot",       label: "ChatBot",         hint: "Conversas do WhatsApp, CLEO, respostas automáticas" },
  { id: "configuracoes", label: "Configurações",   hint: "Horários, sistema, impressão, iFood, assinatura" },
  { id: "indique_ganhe", label: "Indique e Ganhe", hint: "Indicações e descontos na mensalidade" },
];

export const CHAVES_MODULOS = MODULOS.map((m) => m.id);

// Ações de pedido que entram no bloco "Pedidos" do cadastro, ao lado de Reabrir.
// Como Reabrir, não vêm em cargo nenhum: o dono liga por funcionário.
export const PERMISSAO_CANCELAR = "pedido_cancelar";
export const ACOES_PEDIDO = [
  { id: PERMISSAO_CANCELAR, label: "Cancelar pedido", hint: "Em Vendas → Pedidos, confirma com a própria senha em vez da senha do administrador" },
];

/** Cargos prontos. `chavesCaixa` vem de features/caixa (abrir, fechar, movimentar).
 *  Reabrir pedido concluído não vem em cargo nenhum: o dono liga por funcionário. */
export const presetsPorCargo = (chavesCaixa) => ({
  entregador: ["entregas", "pedidos"],
  cozinheiro: ["kds", "pedidos"],
  atendente: ["pedidos", "mesas", "comandas", "balcao", "delivery", ...chavesCaixa],
  gerente: [...CHAVES_MODULOS, ...chavesCaixa],
});
